import { HOST, TENANTS_NAMES } from './host_config';
import xpo from './configs_post_login/xpo';
import intraser from './configs_post_login/intraser';
import ontruck from './configs_post_login/ontruck';
import acme from './configs_post_login/acme';

export const getTenantPostLoginConfig = () => {
  const tenantConfig = {
    [TENANTS_NAMES.intraser]: intraser,
    [TENANTS_NAMES.xpo]: xpo,
    [TENANTS_NAMES.ontruck]: ontruck,
    [TENANTS_NAMES.acme]: acme,
  };
  return { ...tenantConfig[HOST] };
};
